import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import WebScanner from './components/WebScanner';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (window.location.pathname === '/scanner') {
  root.render(<WebScanner />);
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
